export default "__VITE_ASSET__DgRjWXRq__"